import api from "@/lib/api";

export const readNotificationSettings = async signal => (await api.get("/system-settings/NOTIFICATION", { signal })).data;

export const saveNotificationSettings = async settings => {
  const body = Object.fromEntries(Object.entries(settings).filter(([key]) => key !== "_policy" && !key.endsWith("_set")));
  if (body.sms_integration_revision === "") body.sms_integration_revision = null;
  return (await api.put("/system-settings/NOTIFICATION", body)).data;
};

export const sendTestEmail = async to => (await api.post("/notifications/test-email", { to })).data;

export const listSmsIntegrations = async signal => (await api.get("/api-integrations", { signal })).data.items || [];

export const readUserNotifications = async signal => (await api.get("/notifications/inbox", { signal })).data;
export const saveNotificationPreferences = async (enabled, signal) => (await api.put("/notifications/preferences", { down_payment_extension_toasts: enabled }, { signal })).data;
export const markNotificationRead = async (id, signal) => (await api.patch(`/notifications/inbox/${encodeURIComponent(id)}/read`, {}, { signal })).data;
export const markAllNotificationsRead = async (through, signal) => (await api.patch("/notifications/inbox/read-all", { through }, { signal })).data;
export const claimNotificationToast = async (id, signal) => (await api.put(`/notifications/inbox/${encodeURIComponent(id)}/toast-claim`, {}, { signal, globalLoader: false })).data;
